module.exports = __webpack_public_path__ + "static/img/icon_32_weixin.fd98abfe.svg";